import axios from 'axios';

export default {
  getAll(params = {}) {
    return axios.get('/v1/taxonomies', { params });
  },
  detail(id) {
    return axios.get(`/v1/taxonomies/${id}`);
  },
  create(data) {
    return axios.post('/v1/taxonomies', data);
  },
  update(id, params) {
    return axios.put(`/v1/taxonomies/${id}`, params);
  },
  delete(id) {
    return axios.delete(`/v1/taxonomies/${id}`);
  }
};
